import React, { useEffect, useState } from 'react'
import SubheaderInventoryHistory from '../components/InventoryHistory/SubheaderInventoryHistory'
import InventoryHistoryList from '../components/InventoryHistory/InventoryHistoryList'
import { ContentArea } from '../components/Page/logix2020/ContentArea'
import BigFooter from '../components/Footer/BigFooter'
import { useParams } from 'react-router-dom'
import useStores from '../stores/useStore'

const InventoryHistoryPage = () => {
    const { employeeId } = useParams()
    const { profileStore } = useStores()
    const [businessPartnerId, setBusinessPartnerId] = useState(employeeId || null)

    useEffect(() => {
        if (employeeId) {
            setBusinessPartnerId(employeeId)
        } else {
            profileStore.loadProfile().then(profile => setBusinessPartnerId(profile.id))
        }
    }, [employeeId, profileStore])

    return (
        <>
            <SubheaderInventoryHistory />
            <ContentArea>
                <div className='container-fluid'>
                    {businessPartnerId && <InventoryHistoryList businessPartnerId={businessPartnerId} />}
                </div>
            </ContentArea>
            <BigFooter />
        </>
    )
}

export default InventoryHistoryPage